import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback } from 'react';
import { getDefaultLoginParams, resolveAuthEntryPoint } from '../auth/loginDefaults';
import useCustomLocale from './use-custom-locale';
export { resolveAuthEntryPoint };
export function useAuth0Navigation() {
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language;
  var encodeState = useCallback(value => {
    if (!value || typeof window === 'undefined') {
      return value;
    }
    try {
      var binary = new TextEncoder().encode(value).reduce((acc, byte) => acc + String.fromCharCode(byte), '');
      return window.btoa(binary);
    } catch (error) {
      console.error('Failed to encode state', error);
      return value;
    }
  }, []);
  var buildLoginUrl = useCallback(function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (typeof window === 'undefined') return '';
    var currentUrl = options.returnTo || window.location.href;
    var loginUrl = new URL('/auth/login', window.location.origin);
    var defaultParams = getDefaultLoginParams({
      currentUrl,
      origin: window.location.origin,
      language,
      connection: process.env.NEXT_PUBLIC_AUTH0_CONNECTION
    });
    Object.entries(defaultParams).forEach(_ref => {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      loginUrl.searchParams.set(key, value);
    });
    if (options.maxAge) {
      loginUrl.searchParams.set('max_age', options.maxAge);
    }
    if (options.prompt) {
      loginUrl.searchParams.set('prompt', options.prompt);
    }
    if (options.screenHint) {
      loginUrl.searchParams.set('screen_hint', options.screenHint);
    }
    if (options.userEmail) {
      loginUrl.searchParams.set('login_hint', options.userEmail);
    }
    if (options.stateValue) {
      loginUrl.searchParams.set('state', encodeState(options.stateValue));
    }
    if (options.email) {
      loginUrl.searchParams.set('ext-email', options.email);
    }
    if (options.firstName) {
      loginUrl.searchParams.set('ext-firstName', options.firstName);
    }
    if (options.lastName) {
      loginUrl.searchParams.set('ext-lastName', options.lastName);
    }
    if (options.basketReference) {
      loginUrl.searchParams.set('ext-basketReference', options.basketReference);
    }
    return loginUrl.toString();
  }, [language, encodeState]);
  var buildSignupUrl = useCallback(function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return buildLoginUrl(_objectSpread(_objectSpread({}, options), {}, {
      screenHint: 'signup'
    }));
  }, [buildLoginUrl]);
  var buildLogoutUrl = useCallback(returnTo => {
    if (typeof window === 'undefined') return '';
    var logoutUrl = new URL('/auth/logout', window.location.origin);
    var destination = returnTo || window.location.origin;
    logoutUrl.searchParams.set('returnTo', destination);
    return logoutUrl.toString();
  }, []);
  var navigateToLogin = useCallback(options => {
    var url = buildLoginUrl(options);
    window.location.href = url;
  }, [buildLoginUrl]);
  var navigateToSignup = useCallback(options => {
    var url = buildSignupUrl(options);
    window.location.href = url;
  }, [buildSignupUrl]);
  var navigateToLogout = useCallback(returnTo => {
    var url = buildLogoutUrl(returnTo);
    window.location.href = url;
  }, [buildLogoutUrl]);
  return {
    buildLoginUrl,
    buildSignupUrl,
    buildLogoutUrl,
    navigateToLogin,
    navigateToSignup,
    navigateToLogout,
    language
  };
}